export { JointUtilization as default } from '@/components/pages/Legal/JointUtilization'
